import { SalaryCalculation } from "@oysterhr/schema"
import { Icon, Text } from "@oysterhr/ui"
import { Trans, useTranslation } from "react-i18next"
import classNames from "classnames"
import { CountryInformation } from "./CountryInformation"
import { useCalculationsProvider } from "../../contexts"
import { QuoteEmployerCard } from "../QuoteEmployerCard"
import { QuoteEmployeeCard } from "../QuoteEmployeeCard"
import { HireBanner } from "@oysterhr/monetization"

interface ActiveCalculationCardProps {
  calculation: SalaryCalculation
}

export const ActiveCalculationCard = ({ calculation }: ActiveCalculationCardProps) => {
  const { t } = useTranslation("CostCalculator")
  const { cycle } = useCalculationsProvider()

  return (
    <>
      <div className={"w-full rounded-md border-2 border-gray-200 lg:grid"}>
        {/* Information */}
        <div className={"grid grid-cols-1 gap-2 lg:grid-cols-2"}>
          <div
            className={
              "col-span-2 border-b-2 border-gray-200 lg:col-span-1 lg:border-b-0 lg:border-r-2"
            }
          >
            <QuoteEmployerCard
              annualGrossSalary={calculation.annualGrossSalary}
              cycle={cycle}
              calculation={calculation}
            />
          </div>
          <div className="col-span-2 lg:col-span-1">
            <QuoteEmployeeCard
              annualGrossSalary={calculation.annualGrossSalary}
              cycle={cycle}
              calculation={calculation}
            />
          </div>
        </div>
        <div className={classNames("mt-6 border-t-2 border-gray-200 p-4 lg:mt-0", {})}>
          <CountryInformation
            countryCode={calculation.country.code}
            countryName={calculation.country.name}
            countryLiabilityTier={calculation.country.liability?.tier}
            countryLiabilityLink={calculation.country.liability?.link}
            countryNotes={calculation.country.notes}
          />
        </div>
        <HireBanner countryCode={calculation.country.code} />
      </div>
      <div className="my-4 flex w-full items-center rounded-md bg-gray-100 px-4 py-2 shadow">
        <div className="self-start">
          <Icon name="WarningOctagon" size="sm" />
        </div>
        <Text className="ml-2 text-sm text-black">
          <Trans
            defaults={t("estimationNote")}
            components={{
              b: <b />,
            }}
          />
        </Text>
      </div>
    </>
  )
}
